import { View } from 'foundations-components/components/View';

// Override the default tab spacing for UIRouterTab content by adding extra spacing to the top and removing the horizontal spacing
import { jsx as _jsx } from "react/jsx-runtime";
const TabLiner = ({
  children
}) => {
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: "200",
    marginInline: "-400",
    children: children
  });
};
export default TabLiner;